import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

const SKELETON_LABEL_HEIGHT = 16;
const SKELETON_LABEL_WIDTH = 100;
const SKELETON_INPUT_HEIGHT = 40;

export const ProspectEditFormSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();

  const inputBorderRadius = theme.sk.radii.radiusSmall;

  return (
    <View style={styles.form}>
      <View style={styles.inputGroup}>
        <AnimatedSkeletonLoader
          height={SKELETON_LABEL_HEIGHT}
          width={SKELETON_LABEL_WIDTH}
        />
        <AnimatedSkeletonLoader
          borderRadius={inputBorderRadius}
          height={SKELETON_INPUT_HEIGHT}
        />
      </View>
      <View style={styles.inputGroup}>
        <AnimatedSkeletonLoader
          height={SKELETON_LABEL_HEIGHT}
          width={SKELETON_LABEL_WIDTH}
        />
        <AnimatedSkeletonLoader
          borderRadius={inputBorderRadius}
          height={SKELETON_INPUT_HEIGHT}
        />
        <AnimatedSkeletonLoader
          borderRadius={inputBorderRadius}
          height={SKELETON_INPUT_HEIGHT}
        />
        <View style={styles.inputRow}>
          <View style={styles.inputRowField}>
            <AnimatedSkeletonLoader
              borderRadius={inputBorderRadius}
              height={SKELETON_INPUT_HEIGHT}
            />
          </View>
          <View style={styles.inputRowField}>
            <AnimatedSkeletonLoader
              borderRadius={inputBorderRadius}
              height={SKELETON_INPUT_HEIGHT}
            />
          </View>
        </View>
      </View>
      <View style={styles.inputGroup}>
        <AnimatedSkeletonLoader
          height={SKELETON_LABEL_HEIGHT}
          width={SKELETON_LABEL_WIDTH}
        />
        <AnimatedSkeletonLoader
          borderRadius={inputBorderRadius}
          height={SKELETON_INPUT_HEIGHT}
        />
      </View>
      <View style={styles.inputGroup}>
        <AnimatedSkeletonLoader
          height={SKELETON_LABEL_HEIGHT}
          width={SKELETON_LABEL_WIDTH}
        />
        <AnimatedSkeletonLoader
          borderRadius={inputBorderRadius}
          height={SKELETON_INPUT_HEIGHT}
        />
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  form: {
    gap: theme.sk.spacing.spaceMedium,
  },
  inputGroup: {
    gap: theme.sk.spacing.spaceXsmall,
  },
  inputRow: {
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
  inputRowField: {
    flex: 1,
  },
}));
